<template>
    <v-container>

        <div v-if="showcargando == true" id="cargando" wire:loading
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">

                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Buscar usuario</span>
                    </v-card-title>
                    <v-card-text>

                        <v-text-field class="w-1/2"
                                      @keypress="HandleTextInput($event, 'LEV2')"
                                      v-model="displayInputs.uslogin" label="Nombre usuario" variant="outlined"
                                      v-on:input="RecargarDataTable"></v-text-field>
                        <v-row style="padding:10px;" align="center" justify="center">
                            <v-radio-group v-on:change="RecargarDataTable" v-model="displayInputs.Activo"
                                           style="margin: -1px; margin-left: 10px;" row>
                                <v-radio label="Activos" v-bind:value="true"></v-radio>
                                <v-radio label="Inactivos" v-bind:value="false"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row align="center" justify="center">
                            <v-radio-group v-on:change="RecargarDataTable" v-model="displayInputs.InternoExternoTodo"
                                           style="margin: -1px; margin-left: 10px;" row>
                                <v-radio label="Interno" v-bind:value="1"></v-radio>
                                <v-radio label="Externo" v-bind:value="2"></v-radio>
                                <v-radio label="Interno y externo" v-bind:value="3"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <DataTable v-if="mostrarTabla" :url="url" :columns="headers" :dom="'rtip'"
                                   :formatterActions="formatterActions" :params="displayInputs" :order="[]"
                                   @apiDT="apiDT = $event">
                        </DataTable>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Sistemas from "@/services/Sistemas/sistemas.service.js";
    import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
            Menu,
        },
        data() {
            return {
                showcargando: true,
                mostrarTabla: false,
                apiDT: null,
                url: 'Sistemas/BuscarUsuario',
                displayInputs: {
                    uslogin: "",
                    Activo: true,
                    InternoExternoTodo: 3

                },
                headers: [
                    { name: "Login", data: "Login", title: "Login", formatter: [this, "ObtenerFormatoUsuario"] },
                    { name: "Nombre", data: "Nombre", title: "Nombre" },
                    { name: "Puesto", data: "Puesto", title: "Puesto" },
                    { name: "Estatus", data: "Estatus", title: "Estatus", formatter: [this, "FormatearEstatus"] },

                ],
                formatterActions: [
                    { click: [this, "VerDetalleUsuario"] },
                ],
                columnDefs: [
                    {
                        targets: 2, // Tu primera columna
                        className: "dt-body-right",
                    }
                ],
                nombreUsuario: ""
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {

            async VerDetalleUsuario(params, item, fila) {
                await MetodosGenerales.guardarEnSesionInfoReporte(item, 'DetalleUsuarioBusqueda');
                this.$router.push({ name: 'DetalleUsuario' }).catch(error => error);
            },
            RecargarDataTable() {
                if (this.displayInputs.uslogin.trim().length < 3) {
                    this.mostrarTabla = false
                    return
                }

                this.mostrarTabla = true
                if (this.apDT != null) {
                    this.apDT.ajax.reload(null, false);
                    this.apDT.columns.adjust().responsive.recalc();
                }
            },
            ObtenerFormatoUsuario(datos) {
                return `<div class="ml-2"><button type="button"  class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0"aria-expanded="false"><span class='reporteindice'>${datos.Login}</span></button></div>`


            },
            FormatearEstatus(datos) {
                return `<div style="width: 50px"><center>
                <svg width="25"  fill=${datos.Bloqueada == 1 ? "#ddad46" : datos.Estatus ? "#318c58" : "#c14e4e"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>
                </center></div>`;
            },
            HandleTextInput(e, tipo) {
                return MetodosGenerales.validarRegex(e, tipo);
            }

        },
        async mounted() {
            this.showcargando = false;
        },
    }
</script>
<style scoped>
    Cens {
        text-align-last: center !important;
    }
</style>